<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="222.592"
    viewBox="0 0 222.592 94.012"
    style="height: 100%; width: auto"
  >
    <g transform="translate(-233.214 -378.054)">
      <path
        d="M302.7,439.041c-4.956,17.991-16.93,22.281-29.306,18.871s-20.465-13.225-15.508-31.216,33.456-33.935,33.456-33.935S307.653,421.05,302.7,439.041Z"
        fill="none"
        stroke="#fff"
        stroke-miterlimit="10"
        stroke-width="1.129"
      />
      <path
        d="M290.836,393.28s-28,15.424-32.954,33.416,3.132,27.807,15.508,31.216Z"
        fill="none"
        stroke="#fff"
        stroke-miterlimit="10"
        stroke-width="1.129"
      />
      <path
        d="M290.325,427.4c4.4,18.133-3.98,27.7-16.454,30.729s-24.312-1.622-28.717-19.756,12.766-45.913,12.766-45.913S285.92,409.268,290.325,427.4Z"
        fill="none"
        stroke="#fff"
        stroke-miterlimit="10"
        stroke-width="1.129"
      />
      <path
        d="M257.517,393.093s-16.768,27.147-12.363,45.282,16.244,22.786,28.717,19.756Z"
        fill="none"
        stroke="#fff"
        stroke-miterlimit="10"
        stroke-width="1.129"
      />
      <path
        d="M315.455,445.758v-41.4a4.987,4.987,0,0,0-2.494-4.319l-35.85-20.7a4.988,4.988,0,0,0-4.988,0l-35.85,20.7a4.987,4.987,0,0,0-2.494,4.319v41.4a4.989,4.989,0,0,0,2.494,4.32l35.85,20.7a4.988,4.988,0,0,0,4.988,0l35.85-20.7A4.989,4.989,0,0,0,315.455,445.758Z"
        fill="none"
        stroke="#fff"
        stroke-miterlimit="10"
        stroke-width="1.129"
      />
      <path
        d="M344,405.413h15.637a1.02,1.02,0,0,1,1.02,1.019v.332a1.02,1.02,0,0,1-1.02,1.02H346.38a1.02,1.02,0,0,0-1.02,1.019V420.6a1.02,1.02,0,0,0,1.02,1.02h8.274a1.018,1.018,0,0,1,.971,1.329l-.142.446a1.02,1.02,0,0,1-.971.709H346.38a1.02,1.02,0,0,0-1.02,1.02V441.6a1.02,1.02,0,0,0,1.02,1.02h13.149a1.02,1.02,0,0,1,1.02,1.019v.276a1.02,1.02,0,0,1-1.02,1.019H344a1.019,1.019,0,0,1-1.019-1.019V406.432A1.019,1.019,0,0,1,344,405.413Z"
        fill="#fff"
      />
      <path
        d="M379.717,405.413h.721a1.019,1.019,0,0,1,.973.716l11.695,37.485a1.02,1.02,0,0,1-.974,1.323h-.407a1.019,1.019,0,0,1-.972-.713l-4.1-13.028a1.021,1.021,0,0,0-.973-.713h-11.2a1.02,1.02,0,0,0-.975.72l-4,13.015a1.019,1.019,0,0,1-.974.719h-.354a1.019,1.019,0,0,1-.974-1.319l11.543-37.486A1.02,1.02,0,0,1,379.717,405.413Zm-.607,7.3-4.243,13.966a1.019,1.019,0,0,0,.975,1.316h8.567a1.019,1.019,0,0,0,.974-1.321l-4.324-13.966A1.019,1.019,0,0,0,379.11,412.716Z"
        fill="#fff"
      />
      <path
        d="M399.815,434.886h.423a1,1,0,0,1,.994.8,8.741,8.741,0,0,0,2.816,4.9,9.925,9.925,0,0,0,7.092,2.541,12.084,12.084,0,0,0,7.276-2.09q2.885-2.086,2.884-6.662a6.778,6.778,0,0,0-1.613-4.546,10.171,10.171,0,0,0-4-2.851q-2.382-.96-5.213-2.06t-5.213-2.175a10.361,10.361,0,0,1-4-3.162,7.971,7.971,0,0,1-1.613-5.025,9.059,9.059,0,0,1,3.069-6.832q3.067-2.88,8.838-2.88a17.3,17.3,0,0,1,6.921,1.317,1.012,1.012,0,0,1,.545,1.228l-.135.444a1.007,1.007,0,0,1-1.35.646,15.169,15.169,0,0,0-6.061-1.15,11.118,11.118,0,0,0-6.7,1.92,6.358,6.358,0,0,0-2.646,5.476,5.446,5.446,0,0,0,1.615,3.924,10.434,10.434,0,0,0,4.022,2.541q2.406.877,5.212,1.976t5.213,2.259a10.483,10.483,0,0,1,4.022,3.416,8.986,8.986,0,0,1,1.614,5.364,11.142,11.142,0,0,1-3.1,8.273q-3.1,3.078-9.208,3.076t-9.42-3.246a10.719,10.719,0,0,1-3.317-6.244A1.034,1.034,0,0,1,399.815,434.886Z"
        fill="#fff"
      />
      <path
        d="M433.327,405.413h.343a1.02,1.02,0,0,1,1.02,1.019V419.7a8.389,8.389,0,0,0,2.592,6.6,9.519,9.519,0,0,0,6.589,2.315,11.445,11.445,0,0,0,6.483-1.665,6.794,6.794,0,0,0,3-4.546,1.207,1.207,0,0,0,.021-.225V406.432a1.02,1.02,0,0,1,1.02-1.019h.4a1.019,1.019,0,0,1,1.019,1.019V436.3q0,7.268-4.565,8.782a1.028,1.028,0,0,1-1.294-.652h0a1,1,0,0,1,.442-1.19,5.412,5.412,0,0,0,2.664-3.495,15.615,15.615,0,0,0,.318-3.388V429.87a1.02,1.02,0,0,0-1.622-.816,9.633,9.633,0,0,1-2.4,1.174,15.354,15.354,0,0,1-4.921.876q-5.61,0-8.864-2.964t-3.256-8.781V406.432A1.02,1.02,0,0,1,433.327,405.413Z"
        fill="#fff"
      />
    </g>
  </svg>
</template>
